import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Directive, HostBinding, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appSisFieldLoading]',
  standalone: false
})
export class SisFieldLoadingDirective implements OnChanges, OnDestroy {
  @Input() loading = false;
  @Input() loadedKey: unknown = null;
  @Input() loadedMessage = '';
  @Input() loadFailed = false;

  @HostBinding('class.field-loading') get isLoading(): boolean {
    return this.loading;
  }

  @HostBinding('class.field-loaded') loaded = false;

  @HostBinding('class.field-load-failed') get failed(): boolean {
    return this.loadFailed;
  }

  @HostBinding('attr.aria-busy') get ariaBusy(): string | null {
    return this.loading ? 'true' : null;
  }

  private previousLoading = false;
  private previousLoadedKey: unknown = null;
  private loadedTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private readonly liveAnnouncer: LiveAnnouncer) {}

  ngOnChanges(changes: SimpleChanges): void {
    const loadingCompleted = this.previousLoading && !this.loading;
    const loadedKeyChanged = changes['loadedKey'] && !changes['loadedKey'].firstChange;
    const shouldConfirm = !this.loading && !this.loadFailed && this.loadedKey != null && (loadingCompleted || loadedKeyChanged);

    if (shouldConfirm && (loadingCompleted || this.loadedKey !== this.previousLoadedKey)) {
      this.playLoadedConfirmation();
    }

    this.previousLoading = this.loading;
    this.previousLoadedKey = this.loadedKey;
  }

  ngOnDestroy(): void {
    if (this.loadedTimer) {
      clearTimeout(this.loadedTimer);
    }
  }

  private playLoadedConfirmation(): void {
    this.loaded = false;

    if (this.loadedTimer) {
      clearTimeout(this.loadedTimer);
    }

    requestAnimationFrame(() => {
      this.loaded = true;
      if (this.loadedMessage) {
        this.liveAnnouncer.announce(this.loadedMessage, 'polite');
      }
      this.loadedTimer = setTimeout(() => {
        this.loaded = false;
      }, 1300);
    });
  }
}
